/* import __COLOCATED_TEMPLATE__ from './radio-button.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { isEqual } from '@ember/utils';
let RadioButtonComponent = (_class = class RadioButtonComponent extends Component {
  // value - passed in, required, the value for this radio button
  // groupValue - passed in, required, the currently selected value

  // optionally passed in:
  // disabled - boolean
  // required - boolean
  // name - string
  // radioClass - string
  // radioId - string
  // ariaLabelledby - string
  // ariaDescribedby - string

  get joinedClassNames() {
    const classNames = this.args.classNames;
    if (classNames && classNames.length && classNames.join) {
      return classNames.join(' ');
    }
    return classNames;
  }
  get checkedClass() {
    return this.args.checkedClass || 'checked';
  }
  get checked() {
    return isEqual(this.args.groupValue, this.args.value);
  }
  changed(newValue) {
    let changedAction = this.args.changed;

    // providing a closure action is optional
    if (changedAction) {
      changedAction(newValue);
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "changed", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changed"), _class.prototype), _class);
export { RadioButtonComponent as default };